module.exports = __webpack_public_path__ + "static/media/LeftSidebarCovid.5498eba9.png";